import { AfterContentInit, Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ISelectInput } from '../../..';
import { FILTER_CONTENT_ITEM } from '../../content/token';
import { BaseFilter } from '../base-filter';
import { IFilterToApply } from '@portal/shared/ui/filter/src/lib/search/interfaces/filter-to-apply.interface';
import { UserRoles } from '@portal/shared/auth/authorization/src/lib/enums/user-roles.enum';

@Component({
  selector: 'portal-multiple-selection-filter',
  templateUrl: './multiple-selection-filter.component.html',
  styleUrls: ['./multiple-selection-filter.component.scss'],
  providers: [
    {
      provide: FILTER_CONTENT_ITEM,
      useExisting: MultipleSelectionFilterComponent,
    },
  ],
  standalone: false,
})
export class MultipleSelectionFilterComponent extends BaseFilter implements AfterContentInit {
  @Input() entitiesAdded$ = new BehaviorSubject<ISelectInput[]>(null);
  constructor() {
    super();
  }
  ngAfterContentInit(): void {
    if (this.entitiesAdded$) {
      this.entitiesAdded$.subscribe((entities) => {
        if (entities && entities[this.selector]) {
          this.mapRetainedEntities(entities[this.selector]);
        }
      });
    }
  }

  mapRetainedEntities(value: IFilterToApply[] | Set<IFilterToApply>): void {
    this.entities = this.entities || [];
    const iterable = Array.isArray(value) ? value : Array.from(value || []);
    iterable.forEach((val: IFilterToApply) => {
      const id = val.argument;
      const text = id === UserRoles.PetroSiteAdmin ? 'Merchant' : String(id);

      if (!this.entities.find((e) => e.id === id)) {
        this.entities.push({ id, text });
      }
      this.localPreSelectedEntities.set(id, { id, text });
      this.onEntityAdded({ id, text });
    });

    this.updateEntities();
  }
}
